import React, { useState } from 'react';
import { ChevronDownOutline } from '@olist/design-system-icons';
import { TableCell, DetailedContent } from './styles.js';
import { ButtonIcon } from '../../ButtonIcon/ButtonIcon.js';

const Row = ({ data, detailedContent, columnsLength, hasDetailedContent, }) => {
    const [isOpened, toggleIsOpened] = useState((detailedContent === null || detailedContent === void 0 ? void 0 : detailedContent.opened) || false);
    const handleOpen = () => {
        if (detailedContent === null || detailedContent === void 0 ? void 0 : detailedContent.onClick) {
            detailedContent.onClick(!isOpened);
        }
        toggleIsOpened(!isOpened);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            hasDetailedContent && (React.createElement(TableCell, { detailedContent: true, isOpened: isOpened, highlight: detailedContent && isOpened },
                React.createElement(ButtonIcon, { variation: "secondary", disabled: !detailedContent, icon: React.createElement(ChevronDownOutline, null), onClick: handleOpen, "aria-expanded": isOpened }))),
            data.map(({ key, value }) => (React.createElement(TableCell, { key: key }, value)))),
        detailedContent && isOpened && (React.createElement("tr", null,
            React.createElement(DetailedContent, { colSpan: columnsLength + 1 }, detailedContent.content)))));
};

export { Row as default };
